import * as React from "react";
import AutoRefreshContext from "views/components/contexts/AutoRefreshContext";
const emptyFn = () => {
};
const refreshDisabled = {
  animationId: "",
  refreshConfig: { enabled: false, interval: 0 },
  restartAutoRefresh: emptyFn,
  startAutoRefresh: emptyFn,
  stopAutoRefresh: emptyFn
};
const AutoRefreshDisabledProvider = ({ children }) => /* @__PURE__ */ React.createElement(AutoRefreshContext.Provider, { value: refreshDisabled }, children);
export default AutoRefreshDisabledProvider;
